var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42313",
    "data-name": "Group 42313",
    transform: "translate(-17903 -18706)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15859",
    "data-name": "Rectangle 15859",
    width: 24,
    height: 24,
    transform: "translate(17903 18706)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42302",
    "data-name": "Group 42302",
    transform: "translate(2.385 36.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g370",
    transform: "translate(17902.115 18671.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path372",
    d: "M-621.665-310.833a10.5,10.5,0,0,1-10.5,10.5,10.5,10.5,0,0,1-10.5-10.5,10.5,10.5,0,0,1,10.5-10.5A10.5,10.5,0,0,1-621.665-310.833Z",
    transform: "translate(642.665 321.333)",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g374",
    transform: "translate(17908.414 18676.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path376",
    d: "M-248.667-124.332a4.2,4.2,0,0,1-4.2,4.2,4.2,4.2,0,0,1-4.2-4.2,4.2,4.2,0,0,1,4.2-4.2A4.2,4.2,0,0,1-248.667-124.332Z",
    transform: "translate(257.067 128.532)",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g378",
    transform: "translate(17906.35 18684.412)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path380",
    d: "M0-166.583a6.3,6.3,0,0,1,6.265-5.627,6.3,6.3,0,0,1,6.264,5.627",
    transform: "translate(0 172.21)",
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircleOutlined);
export default __webpack_public_path__ + "static/media/user-circle-outlined.7284e0e4d0b57844ba0fb59978332691.svg";
export { ForwardRef as ReactComponent };